import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IGeneralSettingsCache} from 'external-services/general-settings-service/types';
import {FloorPlanState, ISettingState} from './types';
import {DiaryMobileVersion, loadStatus} from "shared-types/index";
import store from "appRoot/Store";
import {MainViewType} from "app/services/mainViewVisibility/types";
import LocationService from "external-services/location-service";
import {UserPointerType} from "external-services/pointer-detection-service/types";

const NS = 'settingSlice';

const initialState: ISettingState = {
  appVersion: '2.0',
  generalSettings: null,
  isManager: false,
  maxBookingSize: 1000000000000,
  mobileVersion: DiaryMobileVersion.PlusVersion, // @todo: might need to rename this and include Diary
  appLoadState: loadStatus.idle,
  floorplanState: FloorPlanState.NOT_INITIALISED,
  bookingView: MainViewType.TimelineV1,

  // assuming value based on device checks, but this will get overridden by PointerDetectionService
  currentPointerDevice: LocationService.isTouchDevice() ? UserPointerType.TouchUser : UserPointerType.MouseUser
};

export function isBookingCreator() {
  const floorplanSettings = store.getState().floorplanSettingsReducer.floorplanSettings;
  const bookingView = store.getState().settingReducer.bookingView;

  if (bookingView === MainViewType.FloorplanV2 && floorplanSettings.enableBookingCreatorOnFloorplan) {
    return true;
  }
  if ((bookingView === MainViewType.TimelineV1 || bookingView === MainViewType.RunSheet) && floorplanSettings.enableBookingCreatorOnTimeline) {
    return true;
  }
  return false;
}

const settingSlice = createSlice({
  name: 'setting', // used in action types
  initialState,
  reducers: {
    setBookingView: (state: ISettingState, action: PayloadAction<MainViewType>) => {
      state.bookingView = action.payload
    },
    setFloorplanState: (state: ISettingState, action: PayloadAction<FloorPlanState>) => {
      state.floorplanState = action.payload
    },
    setAppVersion: (state: ISettingState, action: PayloadAction<string>) => {
      state.appVersion = action.payload;
    },
    setAppLoadStatus: (state: ISettingState, action: PayloadAction<loadStatus>) => {
      state.appLoadState = action.payload;
    },
    setGeneralSettings: (state: ISettingState, action: PayloadAction<IGeneralSettingsCache>) => {
      state.generalSettings = action.payload;
    },
    setMobileVersion: (state: ISettingState, action: PayloadAction<DiaryMobileVersion>) => {
      state.mobileVersion = action.payload;
    },
    setIsManager: (state: ISettingState, action: PayloadAction<boolean>) => {
      state.isManager = action.payload;
    },
    setMaxBookingSize: (state: ISettingState, action: PayloadAction<number>) => {
      state.maxBookingSize = action.payload;
    },
    setCurrentPointerDevice:  (state: ISettingState, action: PayloadAction<UserPointerType>) => {
      state.currentPointerDevice = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = settingSlice;
// Extract and export each action creator by name
export { actions as settingActions };
// Export the reducer, either as a default or named export
export default reducer;
